import {Device} from "../analytics/types";
import {LocalStorageKey, getFromLocalStorage, setInLocalStorage} from "../localStorage";

export const getDevice = () => getFromLocalStorage(LocalStorageKey.Device);

export const setDevice = (device: Device) => setInLocalStorage(LocalStorageKey.Device, device);
